import React from 'react';
import { getStockAbout } from '@/src/services/stockDetails';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import
import { AboutStocksPage } from '../aboutStocks/AboutStocksPage';
// eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import
import { AboutShimmerLoader } from './AboutShimmerLoader';
import { NoData } from '../../StockDetails/components/NoData';

export interface IAboutText {
  name: string;
  about: string;
}

const MainContainer = styled.div`
  width: 100%;
  padding-bottom: 1.5rem;
  scroll-margin-top: 7.2em;
`;

const BoxContainer = styled.div`
  width: 100%;
  margin: auto;
  border: 1.2px solid #c6ccff;
  border-radius: 10px;
  padding: 2.5rem;
`;

const Data = styled.div`
  font-family: 'neueMontreal-Regular';
  width: 100%;
  display: -webkit-box;
  overflow: hidden;
  line-height: 1.8;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  max-height: 200px;
  overflow-y: auto;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
  text-align: left;
  padding: 18px 0;
  font-family: 'neuePowerTrial-Medium';
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #001317;
`;

export const About = ({
  cocode,
  companyName,
}: {
  cocode: string;
  companyName: string;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store
  const [aboutCompany, setAboutCompany] = useState<IAboutText | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    if (cocode) {
      setLoading(true);
      getStockAbout(cocode)
        .then((response) => {
          setAboutCompany(response.data);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [cocode]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store
  const openModal = () => {
    setIsModalOpen(true);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store
  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (!aboutCompany || Object.entries(aboutCompany).length === 0) {
    return <NoData />;
  }

  return (
    <MainContainer>
      <Title>About {aboutCompany?.name || companyName}</Title>
      {!loading && aboutCompany ? (
        <BoxContainer>
          <Data>{aboutCompany.about}</Data>
        </BoxContainer>
      ) : (
        <NoData />
      )}
    </MainContainer>
  );
};
